import { BarChart3, FileText, Settings2, Wallet } from 'lucide-react'
import { Navigate } from 'react-router'
import { RequirePermission } from '@/features/auth/guards'
import { FamilyFeesPage } from '@/pages/finance/FamilyFeesPage'
import { FeeSetupPage } from '@/pages/finance/FeeSetupPage'
import { FinanceReportsPage } from '@/pages/finance/FinanceReportsPage'
import { InvoiceDetailPage } from '@/pages/finance/InvoiceDetailPage'
import { InvoicesPage } from '@/pages/finance/InvoicesPage'
import { PaymentsPage } from '@/pages/finance/PaymentsPage'
import { ReceiptPage } from '@/pages/finance/ReceiptPage'
import { StudentLedgerPage } from '@/pages/finance/StudentLedgerPage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'finance',
  schoolModule: 'finance',
  routes: {
    admin: [
      {
        path: 'finance',
        children: [
          { index: true, element: <Navigate to="invoices" replace /> },
          {
            element: <RequirePermission permission="finance.view" />,
            children: [
              { path: 'invoices', element: <InvoicesPage /> },
              { path: 'invoices/:id', element: <InvoiceDetailPage /> },
              { path: 'payments', element: <PaymentsPage /> },
              { path: 'payments/:id/receipt', element: <ReceiptPage /> },
              { path: 'setup', element: <FeeSetupPage /> },
              { path: 'students/:id/ledger', element: <StudentLedgerPage /> },
            ],
          },
          {
            path: 'reports',
            element: (
              <RequirePermission permission="reports.view">
                <FinanceReportsPage />
              </RequirePermission>
            ),
          },
        ],
      },
    ],
    family: [{ path: 'fees', element: <FamilyFeesPage /> }],
  },
  nav: {
    admin: [
      {
        group: 'Finance',
        order: 10,
        item: {
          label: 'Invoices',
          to: '/admin/finance/invoices',
          icon: FileText,
          permission: 'finance.view',
          keywords: 'fees billing generate',
        },
      },
      {
        group: 'Finance',
        order: 20,
        item: {
          label: 'Payments',
          to: '/admin/finance/payments',
          icon: Wallet,
          permission: 'finance.view',
          keywords: 'receipts collections',
        },
      },
      {
        group: 'Finance',
        order: 30,
        item: {
          label: 'Fee setup',
          to: '/admin/finance/setup',
          icon: Settings2,
          permission: 'finance.view',
          keywords: 'fee items categories discounts',
        },
      },
      {
        group: 'Finance',
        order: 40,
        item: {
          label: 'Reports',
          to: '/admin/finance/reports',
          icon: BarChart3,
          permission: 'reports.view',
          keywords: 'outstanding dues debtors collections',
        },
      },
    ],
    family: [
      {
        order: 40,
        item: { label: 'Fees', to: '/portal/fees', icon: Wallet, keywords: 'invoices payments balance' },
      },
    ],
  },
}
